<template>

    <div class="nav-tabs-custom submenu">
        <ul class="nav nav-tabs nav-fixed-tabs">
            <li
                v-for="child in getMenu"
                :class="{'active':isActiveChildRoute(child)}"
            >
                <router-link :to="routeTo(child)">
                    {{ child.name }}
                </router-link>
            </li>
        </ul>
        <div class="tab-content">
            <div class="active tab-pane">
                <router-view></router-view>
            </div>
        </div>
    </div>

</template>

<script>

import {mapActions, mapGetters} from "vuex";
import MenuItem from "../../../Libraries/MenuItem";

export default {

    computed: {
        ...mapGetters([
            'getHrUser',
        ]),
        getMenu() {
            return [
                new MenuItem(this.getHrUser.fullname, {name:'hr.users.show', params:{uuid:this.getHrUser.uuid}}),
                new MenuItem('Contracten', {name:'hr.users.contracts', params:{uuid:this.getHrUser.uuid}}),
                new MenuItem('Urenregistratie', {name:'hr.users.timeregistration', params:{uuid:this.getHrUser.uuid}}),
                new MenuItem('Overuren', {name:'hr.users.overtime', params:{uuid:this.getHrUser.uuid}}),
                new MenuItem('Overuren totalen', {name:'hr.users.overtime.totals', params:{uuid:this.getHrUser.uuid}}),
                new MenuItem('Vakantieuren', {name:'hr.users.vacationhours', params:{uuid:this.getHrUser.uuid}}),
                new MenuItem('Documenten', {name:'hr.users.documents', params:{uuid:this.getHrUser.uuid}}),
            ];
        }
    },

    methods: {
        ...mapActions([
            'setHasSubMenu',
        ]),

        isActiveChildRoute(child) {
            let routeName;
            if (typeof child.route === 'string') {
                routeName = child.route;
            } else {
                routeName = child.route.name;
            }

            if (routeName == 'hr.users.show' && this.$route.name == 'hr.users.edit') {
                return true;
            }

            return routeName === this.$route.name;
        },

        routeTo(child) {
            if (typeof child.route === 'string') {
                return {name:child.route};
            }
            return {
                name:child.route.name,
                params:child.route.params,
            };
        },

    },

    mounted() {
        this.setHasSubMenu(true);
    },

    destroyed() {
        this.setHasSubMenu(false);
    },

    name:'HrUsersLayoutTabs',

}

</script>
